import { CheckOutlined, LockOutlined } from '@ant-design/icons';
import { Tooltip } from '@mm/components';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import { PrimaryButton } from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import CheckBox from '../../../../../../../common/components/Checkbox';
import { GridCell } from '../../../../../../../common/components/Grid/Grid';
import styles from './PurchaseContactsTable.module.css';

const renderTextCell = ({ label, key }: { label: string; key: string }) => {
  const showTooltip = ['occupation', 'city'].includes(key);
  return (
    <GridCell className={styles.gridCell} key={key}>
      {showTooltip ? (
        <Tooltip
          title={label}
          overlayStyle={{ maxWidth: 'fit-content' }}
          getPopupContainer={element =>
            element.parentElement ? element.parentElement : document.body
          }
        >
          <div className={styles.textCell}>{label}</div>
        </Tooltip>
      ) : (
        <div className={styles.textCell}>{label}</div>
      )}
    </GridCell>
  );
};

const renderLocationCell = ({ label }: { label: string }) => (
  <GridCell className={styles.gridCell} key={uniqueId(label)}>
    <div className={styles.textCell}>{label}</div>
  </GridCell>
);

const renderButtonCell = ({
  isConverted,
  key,
  onClick,
}: {
  isConverted?: boolean;
  key: string;
  onClick?: (e) => void;
}) => (
  <GridCell className={styles.gridCell} key={key}>
    {!isConverted ? (
      <PrimaryButton className={styles.purchaseButton} onClick={onClick}>
        <LockOutlined /> Purchase Lead
      </PrimaryButton>
    ) : (
      <div className={styles.purchased}>
        <CheckOutlined className={styles.checkIcon} /> Purchased
      </div>
    )}
  </GridCell>
);

const renderCheckboxCell = ({
  label,
  isConverted,
  key,
  isChecked,
  disabled,
}: {
  label: string;
  key: string;
  isChecked?: boolean;
  disabled?: boolean;
  isConverted?: boolean;
}) => (
  <GridCell className={styles.gridCell} key={key}>
    {!isConverted && (
      <CheckBox
        isChecked={isChecked || false}
        className={styles.checkbox}
        disabled={disabled}
      />
    )}
    <div className={classNames(styles.textCell, styles.firstNameTextCell)}>
      {label?.toLowerCase()}
    </div>
  </GridCell>
);

export const PURCHASE_LEADS_CELL_DATA = [
  {
    label: 'First Name',
    key: 'firstname',
    Cell: renderCheckboxCell,
  },
  {
    label: 'Email',
    key: 'email',
    Cell: renderButtonCell,
  },
  {
    label: 'Gender',
    key: 'sex',
    Cell: renderTextCell,
  },
  {
    label: 'Age',
    key: 'age',
    Cell: renderTextCell,
  },
  {
    label: 'Occupation',
    key: 'occupation',
    Cell: renderTextCell,
  },
  {
    label: 'City',
    key: 'city',
    Cell: renderTextCell,
  },
  {
    label: 'State',
    key: 'state',
    Cell: renderTextCell,
  },
];

export const VOYAGER_LEADS_CELL_DATA = [
  {
    label: 'First Name',
    key: 'firstName',
    Cell: renderCheckboxCell,
  },
  {
    label: 'Email',
    key: 'email',
    Cell: renderButtonCell,
  },
  {
    label: 'Job Title',
    key: 'jobTitle',
    Cell: renderTextCell,
  },
  {
    label: 'Company',
    key: 'companyName',
    Cell: renderTextCell,
  },
  {
    label: 'Location',
    key: 'location',
    Cell: renderLocationCell,
  },
  {
    label: 'Employees',
    key: 'companyEmployeeCount',
    Cell: renderTextCell,
  },
];

const renderCheckboxCellMobile = ({
  label,
  key,
  isChecked,
  disabled,
  isConverted,
}: {
  label: string;
  key: string;
  isChecked?: boolean;
  disabled?: boolean;
  isConverted?: boolean;
}) => (
  <GridCell className={styles.gridCellMobile} key={key}>
    <div className={styles.gridCellMobileHeader}>
      {!isConverted && (
        <CheckBox
          isChecked={isChecked || false}
          className={styles.checkbox}
          disabled={disabled || isChecked}
        />
      )}
      <div
        className={classNames(styles.textCell, styles.firstNameTextCellMobile)}
      >
        {label?.toLowerCase()}
      </div>
    </div>
  </GridCell>
);

const renderButtonCellMobile = ({
  isConverted,
  key,
  onClick,
}: {
  isConverted?: boolean;
  key: string;
  onClick?: (e) => void;
}) => (
  <GridCell className={styles.gridCellMobileButton} key={key}>
    {!isConverted ? (
      <PrimaryButton className={styles.purchaseButtonMobile} onClick={onClick}>
        <LockOutlined /> Purchase Lead
      </PrimaryButton>
    ) : (
      <div className={styles.purchased}>
        <CheckOutlined className={styles.checkIcon} /> Purchased
      </div>
    )}
  </GridCell>
);

export const MOBILE_PURCHASE_LEADS_CELL_DATA = [
  {
    label: 'First Name',
    key: 'firstname',
    Cell: renderCheckboxCellMobile,
  },
  {
    label: 'Email',
    key: 'email',
    Cell: renderButtonCellMobile,
  },
];
